import { defineNuxtPlugin } from '@nuxtjs/composition-api';

export default defineNuxtPlugin(({ app: { $analytics } }) => {
  window.onNuxtReady(() => {
    $analytics.logPageView();
  });
});
